import { TableColumnWithIcon } from 'components/Table/TableBody/TableColumnWithIcon';
import { useTranslation } from 'react-i18next';
import { BsCalendar3 } from 'react-icons/bs';

interface DurationIconProps {
  label: number;
}

export const DurationIcon = ({ label }: DurationIconProps) => {
  const { t } = useTranslation();
  return (
    <TableColumnWithIcon icon={<BsCalendar3 />} label={`${label} ${label === 1 ? t('day_label') : t('days_label')}`} />
  );
};
